import React from 'react'

import { Routes as ReactRouter, Route, Outlet } from 'react-router-dom'

import { PrivateRoute } from './PrivateRoute'

import { Loading } from '../layouts/Loading'
import Accredited from '../pages/Accredited'

const SignIn = React.lazy(() => import('../pages/SignIn'))

const SignUp = React.lazy(() => import('../pages/SignUp'))
const SignUpBusiness = React.lazy(() => import('../pages/SignUp/Business'))
const SignUpConfiguration = React.lazy(
  () => import('../pages/SignUp/Configuration')
)
const SignUpCharacteristics = React.lazy(
  () => import('../pages/SignUp/Characteristics')
)

const Dashboard = React.lazy(() => import('../pages/Dashboard'))
const Booking = React.lazy(() => import('../pages/Booking'))
const Management = React.lazy(() => import('../pages/Management'))
const Financial = React.lazy(() => import('../pages/Financial'))
const Coupons = React.lazy(() => import('../pages/Coupons'))
const Monthly = React.lazy(() => import('../pages/Monthly'))
const Rating = React.lazy(() => import('../pages/Rating'))
const Configuration = React.lazy(() => import('../pages/Configuration'))
const Home = React.lazy(() => import('../pages/Home'))
const Users = React.lazy(() => import('../pages/Users'))
const ConfigurationAdmin = React.lazy(
  () => import('../pages/ConfigurationAdmin')
)

const ResetPassword = React.lazy(
  () => import('../pages/Password/ResetPassword')
)
const ForgotPassword = React.lazy(
  () => import('../pages/Password/ForgotPassword')
)

const NotFound = React.lazy(() => import('../pages/NotFound'))
const PermissionRefused = React.lazy(() => import('../pages/PermissionRefused'))

export function Routes() {
  return (
    <ReactRouter>
      <Route
        path="/"
        element={
          <React.Suspense fallback={<Loading />}>
            <SignIn />
          </React.Suspense>
        }
      />

      <Route path="/signup" element={<Outlet />}>
        <Route
          index
          element={
            <React.Suspense fallback={<Loading />}>
              <SignUp />
            </React.Suspense>
          }
        />
        <Route
          path="business"
          element={
            <React.Suspense fallback={<Loading />}>
              <SignUpBusiness />
            </React.Suspense>
          }
        />
        <Route
          path="configuration"
          element={
            <React.Suspense fallback={<Loading />}>
              <SignUpConfiguration />
            </React.Suspense>
          }
        />
        <Route
          path="characteristics"
          element={
            <React.Suspense fallback={<Loading />}>
              <SignUpCharacteristics />
            </React.Suspense>
          }
        />
      </Route>

      <Route element={<PrivateRoute />}>
        <Route
          path="/dashboard"
          element={
            <React.Suspense fallback={<Loading />}>
              <Dashboard />
            </React.Suspense>
          }
        />
        <Route
          path="/home"
          element={
            <React.Suspense fallback={<Loading />}>
              <Home />
            </React.Suspense>
          }
        />
        <Route
          path="/management"
          element={
            <React.Suspense fallback={<Loading />}>
              <Management />
            </React.Suspense>
          }
        />
        <Route
          path="/booking"
          element={
            <React.Suspense fallback={<Loading />}>
              <Booking />
            </React.Suspense>
          }
        />
        <Route
          path="/financial"
          element={
            <React.Suspense fallback={<Loading />}>
              <Financial />
            </React.Suspense>
          }
        />
        <Route
          path="/coupons"
          element={
            <React.Suspense fallback={<Loading />}>
              <Coupons />
            </React.Suspense>
          }
        />
        <Route
          path="/monthly"
          element={
            <React.Suspense fallback={<Loading />}>
              <Monthly />
            </React.Suspense>
          }
        />
        <Route
          path="/accredited"
          element={
            <React.Suspense fallback={<Loading />}>
              <Accredited />
            </React.Suspense>
          }
        />
        <Route
          path="/users"
          element={
            <React.Suspense fallback={<Loading />}>
              <Users />
            </React.Suspense>
          }
        />
        <Route
          path="/rating"
          element={
            <React.Suspense fallback={<Loading />}>
              <Rating />
            </React.Suspense>
          }
        />
        <Route
          path="/configuration-admin"
          element={
            <React.Suspense fallback={<Loading />}>
              <ConfigurationAdmin />
            </React.Suspense>
          }
        />
        <Route
          path="/configuration/:parking_id"
          element={
            <React.Suspense fallback={<Loading />}>
              <Configuration />
            </React.Suspense>
          }
        />
      </Route>

      <Route
        path="/forgot-password"
        element={
          <React.Suspense fallback={<Loading />}>
            <ForgotPassword />
          </React.Suspense>
        }
      />
      <Route
        path="/reset-password"
        element={
          <React.Suspense fallback={<Loading />}>
            <ResetPassword />
          </React.Suspense>
        }
      />

      <Route
        path="*"
        element={
          <React.Suspense fallback={<Loading />}>
            <NotFound />
          </React.Suspense>
        }
      />

      <Route
        path="/refused"
        element={
          <React.Suspense fallback={<Loading />}>
            <PermissionRefused />
          </React.Suspense>
        }
      />
    </ReactRouter>
  )
}
